{
  "title": "إرسال رسالة",
  "messageText": "نص الرسالة",
  "messageTextPlaceholder": "اكتب نص الرسالة...",
  "characterCount": "{{count}}/{{max}} حرفا",
  "selectAll": "تحديد الكل",
  "searchLabel": "البحث عن مدين",
  "searchPlaceholder": "البحث بالاسم أو رقم الهاتف...",
  "recipientsTitle": "عملاء الذمم",
  "selectedCount": "تم اختيار {{count}} من {{total}}",
  "invalidPhoneReason": "رقم غير صالح",
  "send": "إرسال",
  "confirmSend": "إرسال الرسالة إلى {{count}} من عملاء الذمم",
  "confirmSendDescription": "سيتم إرسال الرسالة إلى عملاء الذمم الذين حددتهم فقط.",
  "status": {
    "queued": "قيد الإرسال",
    "sent": "تم الإرسال",
    "delivered": "تم التسليم",
    "read": "تمت القراءة",
    "failed": "فشل الإرسال",
    "invalid_phone": "رقم غير صالح"
  },
  "toasts": {
    "result": "تم إرسال الرسالة إلى {{queued}} وتخطي {{skipped}} لرقم غير صالح"
  },
  "validation": {
    "messageRequired": "هذا الحقل مطلوب",
    "noRecipients": "اختر مدينا واحدا على الأقل"
  },
  "empty": {
    "noResults": "لا توجد نتائج"
  }
}
